export default "__VITE_ASSET__UBI$u2yg__"